const drawerWidth = 200;

export const useStyles = (theme) => ({
  root: {
    marginLeft: drawerWidth,
    minHeight: "100vh",
    padding: 30,
    marginTop: 50,
    backgroundColor: "#f9f9fc",
    [theme.breakpoints.down("sm")]: {
      marginLeft: "auto",
      marginRight: "auto",
      padding: 20,
    },
  },
});
